module.exports = __webpack_public_path__ + "static/WEDDING E&M-597-6d0bf9d6a8dedb2bc8fc9b53a0fc7441.jpg";